import React, { useEffect, useState } from 'react';
import { Link, Navigate, Outlet, useNavigate } from 'react-router-dom';
import { useUser } from '../../auth/UseUser';
import SideBar from '../SideBar';

function Layout() {
	const { user, setUser, isSignedIn } = useUser();
	const navigate = useNavigate();

	useEffect(() => {
		console.log('i am here : ', isSignedIn);
		//navigate('/courses');
	}, []);

	return (
		<div className='home h-screen overflow-y-hidden'>
			<div className=' w-full h-full'>
				<div className=' w-full h-full flex flex-row'>
					<SideBar />

					{/* An <Outlet> renders whatever child route is currently active,
          so you can think about this <Outlet> as a placeholder for
          the child routes we defined above. */}
					<div id='home-container' className=' h-full w-full transition'>
						<Outlet />
					</div>
				</div>
			</div>
		</div>
	);
}

export default Layout;
